import { getHireJobsApplicantsTimelineRetrieveQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { jobId: string; applicantId: string | undefined };

export const applicantTimelineQuery = ({ jobId, applicantId }: QueriesInput) =>
  getHireJobsApplicantsTimelineRetrieveQueryOptions(jobId, applicantId ?? "", { query: { enabled: !!applicantId } });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [applicantTimelineQuery(input)];
